import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-obs-social',
  templateUrl: './obs-social.component.html',
  styleUrls: ['./obs-social.component.css'],
})
export class ObsSocialComponent implements OnInit {
  url: string = 'socialObservability';
  searchText = '';
  filteredData: Array<any> = [];
  data: Array<any> = [];
  loading = false;

  // Filters
  selectedPeriod: string = 'daily';
  selectedPlatform: string = '';
  selectedDate: string = '';

  // Active section tab
  activeSection:
    | 'output'
    | 'distribution'
    | 'conversion'
    | 'quality'
    | 'health'
    | 'reason'
    | 'touchbase'
    | 'inventory' = 'output';

  // Health state badge
  healthState: string = 'SOCIAL_HEALTHY';
  activeSignals: string[] = [];
  safeStateActive = false;

  // Output KPIs
  outputKpis = [
    {
      label: 'Posts Published',
      field: 'posts_published_count',
      value: 0,
      icon: 'fas fa-paper-plane',
      color: '#455e72',
    },
    {
      label: 'Posts Scheduled',
      field: 'posts_scheduled_count',
      value: 0,
      icon: 'fas fa-clock',
      color: '#6c757d',
    },
    {
      label: 'Inventory Ready',
      field: 'inventory_ready_count',
      value: 0,
      icon: 'fas fa-box-open',
      color: '#28a745',
    },
    {
      label: 'Refresh Due',
      field: 'refresh_due_count',
      value: 0,
      icon: 'fas fa-sync-alt',
      color: '#ffc107',
    },
  ];

  // Distribution KPIs
  distributionKpis = [
    {
      label: 'Reach',
      field: 'reach',
      value: 0,
      icon: 'fas fa-bullseye',
      color: '#455e72',
    },
    {
      label: 'Impressions',
      field: 'impressions',
      value: 0,
      icon: 'fas fa-eye',
      color: '#17a2b8',
    },
    {
      label: 'Views',
      field: 'views',
      value: 0,
      icon: 'fas fa-video',
      color: '#6610f2',
    },
    {
      label: 'Profile Visits',
      field: 'profile_visits',
      value: 0,
      icon: 'fas fa-user-circle',
      color: '#fd7e14',
    },
    {
      label: 'Engagement Rate',
      field: 'engagement_rate',
      value: 0,
      icon: 'fas fa-chart-line',
      color: '#20c997',
      isPercent: true,
    },
  ];

  // Conversion KPIs
  conversionKpis = [
    {
      label: 'Link Clicks',
      field: 'link_clicks',
      value: 0,
      icon: 'fas fa-link',
      color: '#455e72',
    },
    {
      label: 'WhatsApp Started',
      field: 'whatsapp_started_count',
      value: 0,
      icon: 'fab fa-whatsapp',
      color: '#25d366',
    },
    {
      label: 'DM Started',
      field: 'dm_started_count',
      value: 0,
      icon: 'fas fa-envelope',
      color: '#6c757d',
    },
    {
      label: 'Call Initiated',
      field: 'call_initiated_count',
      value: 0,
      icon: 'fas fa-phone',
      color: '#17a2b8',
    },
    {
      label: 'Booking Flow',
      field: 'booking_flow_started_count',
      value: 0,
      icon: 'fas fa-calendar-plus',
      color: '#fd7e14',
    },
    {
      label: 'Booking Completed',
      field: 'booking_completed_count',
      value: 0,
      icon: 'fas fa-calendar-check',
      color: '#28a745',
    },
  ];

  // Quality KPIs
  qualityKpis = [
    {
      label: 'Valid Lead Rate',
      field: 'valid_lead_rate',
      value: 0,
      icon: 'fas fa-check-circle',
      color: '#28a745',
      isPercent: true,
    },
    {
      label: 'Invalid Lead Rate',
      field: 'invalid_lead_rate',
      value: 0,
      icon: 'fas fa-times-circle',
      color: '#dc3545',
      isPercent: true,
    },
  ];

  invalidReasonDistribution: { reason: string; count: number }[] = [];

  // Touch Base Response Time
  responseTimeAvg: number = 0;
  responseTimeP95: number = 0;

  // Inventory / Refresh Backlog
  inventoryReady: number = 0;
  refreshDue: number = 0;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  healthStateMap: Record<string, { label: string; badgeClass: string }> = {
    SOCIAL_HEALTHY: { label: 'Healthy', badgeClass: 'badge-healthy' },
    SOCIAL_WATCH: { label: 'Watch', badgeClass: 'badge-watch' },
    SOCIAL_DEGRADED: { label: 'Degraded', badgeClass: 'badge-degraded' },
    SOCIAL_SAFE_STATE_ACTIVE: {
      label: 'Safe State Active',
      badgeClass: 'badge-safe-state',
    },
  };

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.dataService.getData(this.url + '/scorecards?limit=10').subscribe(
      (response: any) => {
        if (response && response.rst && response.data) {
          this.data = response.data;
          this.filteredData = [...this.data];
          this.applyLatestSnapshot();
        } else {
          this.messageService.add(
            response.msg || 'No se pudieron cargar los datos de Social Observability',
            'secondary'
          );
        }
        this.loading = false;
      },
      (error: any) => {
        this.messageService.add('Error conexion a API Social Observability', 'danger');
        this.loading = false;
        console.error(error);
      }
    );
  }

  applyLatestSnapshot() {
    if (!this.filteredData.length) return;
    const snap = this.filteredData[0];

    this.outputKpis.forEach((k) => (k.value = snap[k.field] ?? 0));
    this.distributionKpis.forEach((k) => (k.value = snap[k.field] ?? 0));
    this.conversionKpis.forEach((k) => (k.value = snap[k.field] ?? 0));
    this.qualityKpis.forEach((k) => (k.value = snap[k.field] ?? 0));

    this.responseTimeAvg = snap.response_time_avg ?? 0;
    this.responseTimeP95 = snap.response_time_p95 ?? 0;
    this.inventoryReady = snap.inventory_ready_count ?? 0;
    this.refreshDue = snap.refresh_due_count ?? 0;
    this.healthState = snap.health_state ?? 'SOCIAL_HEALTHY';
    this.activeSignals = snap.active_signals ?? [];
    this.safeStateActive = snap.safe_state_active ?? false;

    const dist = snap.invalid_reason_distribution ?? {};
    this.invalidReasonDistribution = Object.entries(dist).map(
      ([reason, count]) => ({
        reason,
        count: count as number,
      }),
    );
  }

  filterInfo() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter(
        (item) =>
          (item.platform && item.platform.toLowerCase().includes(texto)) ||
          (item.period_type &&
            item.period_type.toLowerCase().includes(texto)) ||
          (item.health_state &&
            item.health_state.toLowerCase().includes(texto)),
      );
    }
    this.applyLatestSnapshot();
  }

  setSection(section: typeof this.activeSection) {
    this.activeSection = section;
  }

  get healthBadge() {
    return (
      this.healthStateMap[this.healthState] ?? {
        label: this.healthState,
        badgeClass: 'badge-healthy',
      }
    );
  }

  formatValue(value: number, isPercent = false): string {
    if (isPercent) return (value * 100).toFixed(1) + '%';
    if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + 'M';
    if (value >= 1_000) return (value / 1_000).toFixed(1) + 'K';
    return value.toString();
  }

  totalInvalidCount(): number {
    return this.invalidReasonDistribution.reduce((acc, r) => acc + r.count, 0);
  }

}
